// Reads the one error shape every operation answers with (DESIGN.md §9.1, api-contract.yaml
// `Error`), without ever rendering the raw error object. `message` is already Indonesian and safe
// to render (DESIGN.md §9.1); this file never invents its own copy for a specific `code` beyond
// the one DESIGN §8.1.1 already fixes for `csrf_token_invalid`.
// Relative, not `@/` — `frontend/vitest.config.ts` (T-03's, frozen) has no path-alias resolution.
import type { components } from '../../lib/api/client';

export type ApiError = components['schemas']['Error']['error'];

function hasErrorShape(value: unknown): value is { error: ApiError } {
  return (
    typeof value === 'object' &&
    value !== null &&
    'error' in value &&
    typeof (value as { error?: unknown }).error === 'object' &&
    (value as { error?: unknown }).error !== null
  );
}

export function getApiError(error: unknown): ApiError | undefined {
  return hasErrorShape(error) ? error.error : undefined;
}

export function getApiErrorCode(error: unknown): string | undefined {
  return getApiError(error)?.code;
}

export function getApiErrorMessage(error: unknown, fallback: string): string {
  return getApiError(error)?.message ?? fallback;
}

/** DESIGN.md §8.1.1 "Recovery": the one place that knows the shape of a CSRF refusal. */
export function isCsrfTokenInvalid(error: unknown): boolean {
  return getApiErrorCode(error) === 'csrf_token_invalid';
}

export function isAuthenticationRequired(error: unknown): boolean {
  return getApiErrorCode(error) === 'authentication_required';
}

export function isTotpRequired(error: unknown): boolean {
  return getApiErrorCode(error) === 'totp_required';
}
